import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

const catalogOverviewEntityContent = EntityContentBlueprint.make({
  name: 'driveline-overview',
  params: {
    path: '/',
    title: 'Overview',
    group: 'overview',
    loader: () =>
      import('./CatalogOverviewEntityContent').then(module => (
        <module.CatalogOverviewEntityContent />
      )),
  },
});

export const catalogOverviewEntityContentModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [catalogOverviewEntityContent],
});
